import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

/**
 * Ends the session by leaving for the server logout route. The Datadog user
 * is forgotten first, since the SDKs keep it across page loads and would tag
 * the next user's events with it. With "replace", the current page leaves
 * the history, so Back cannot return to it.
 */
const logOut = (navigation: "assign" | "replace"): void => {
  datadogLogs.clearUser();
  datadogRum.clearUser();
  location[navigation]("/logout");
};

export { logOut };
